const u = navigator.userAgent;
const r = window.location.search.toLowerCase();
const ua = navigator.userAgent.toLowerCase();
const pf = navigator.platform.toLowerCase();
const userAgent = {
  isandroid: ua.indexOf("android") > -1 || pf.indexOf("linux") > -1,
  isiphone: ua.indexOf("iphone") > -1 || pf.indexOf("iphone") > -1,
  istoutiaomp: ua.indexOf("toutiaomicroapp") > -1,
  isIpad: ua.indexOf("ipad") > -1 || pf.indexOf("ipad") > -1,
  iswechat: ua.indexOf("micromessenger") > -1,
  isalipay: ua.indexOf("alipayclient") > -1,
  iswebo: ua.indexOf("weibo") > -1,
  isqq: ua.indexOf("qq") > -1 && ua.indexOf("mqqbrowser") == -1,
  ismpwecaht: ua.indexOf("miniProgram") > -1,
  issocialapp: ua.indexOf("micromessenger") > -1 ||
    ua.indexOf("weibo") > -1 ||
    (ua.indexOf("qq") > -1 && ua.indexOf("mqqbrowser") == -1),
  isxzdz: ua.indexOf("xzdz") > -1 ||
    ua.indexOf("xztenant") > -1 ||
    ua.indexOf("mstenant") > -1 ||
    ua.indexOf("xiaozhutianwen") > -1 ||
    ua.indexOf("xzminsu") > -1 ||
    ua.indexOf("xzjiangsu") > -1 ||
    ua.indexOf("xzkuaipao") > -1,
  xzminsu: ua.indexOf("xzminsu") > -1,
  isxzapp: r.indexOf("xzappinstall") > -1 ||
    ua.indexOf("xzdz") > -1 ||
    ua.indexOf("xztenant") > -1 ||
    ua.indexOf("mstenant") > -1 ||
    ua.indexOf("xiaozhutianwen") > -1 ||
    ua.indexOf("xzminsu") > -1 ||
    ua.indexOf("xzjiangsu") > -1 ||
    ua.indexOf("xzkuaipao") > -1,
  isxzapp_ios: (ua.indexOf("iphone") > -1 || ua.indexOf("ipad") > -1) &&
    (pf.indexOf("iphone") > -1 || pf.indexOf("ipad") > -1) &&
    (r.indexOf("xzappinstall") > -1 ||
      ua.indexOf("xzdz") > -1 ||
      ua.indexOf("xztenant") > -1 ||
      ua.indexOf("mstenant") > -1 ||
      ua.indexOf("xiaozhutianwen") > -1 ||
      ua.indexOf("xzminsu") > -1 ||
      ua.indexOf("xzjiangsu") > -1 ||
      ua.indexOf("xzkuaipao") > -1),
  isxzapp_android: ua.indexOf("android") > -1 &&
    pf.indexOf("linux") > -1 &&
    (ua.indexOf("xzdz") > -1 ||
      ua.indexOf("xztenant") > -1 ||
      ua.indexOf("mstenant") > -1 ||
      ua.indexOf("xiaozhutianwen") > -1 ||
      ua.indexOf("xzminsu") > -1 ||
      ua.indexOf("xzjiangsu") > -1 ||
      ua.indexOf("xzkuaipao") > -1),
  new_ios: ua.indexOf("xzapp/ios") > -1,
  new_android: ua.indexOf("xzapp/android") > -1,
  isjdapp: !!(
    ua.indexOf("jdjr-app") > -1 ||
    ua.indexOf("jdapp") > -1 ||
    sessionStorage.getItem("isjd")
  ),
  badfish: ua.indexOf("aliapp(fm") > -1,
  crashProtection: ua.indexOf("xzcrashprotection") > -1,
  istoutiao: ua.indexOf("toutiaomicroapp") > -1,
  isMinsuwang: ua.indexOf("minsuwang") > -1,
  isDouYin: ua.indexOf("bytelocale") > -1,
  isTalentApp: ua.indexOf("talent") > -1,
  isLark: ua.indexOf("eemicroapp") > -1,
  baiduMap: ua.indexOf("baidumap_ ") > -1
};
export default {
  userAgent
};



// WEBPACK FOOTER //
// ./src/utils/getUa.js